import { AppProps } from 'next/app';
import Head from 'next/head';
import Script from 'next/script';
import { ApolloProvider } from '@apollo/client';

import client from '../lib/apollo';
import CriticalCSS from '../components/CriticalCSS';
import '../styles/globals.css';

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        {/* Safari compatibility meta tags */}
        <meta name="format-detection" content="telephone=no" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <meta name="apple-touch-fullscreen" content="yes" />
        
        {/* Enhanced viewport for Safari */}
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes, viewport-fit=cover" />
        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        
        {/* Critical resource preloading for LCP optimization */}
        <link rel="preload" href="/images/optimized/logo-mobile.webp" as="image" type="image/webp" fetchPriority="high" />
        <link rel="preload" href="/images/optimized/logo-desktop.webp" as="image" type="image/webp" fetchPriority="high" />
        
        {/* DNS prefetch for external resources */}
        <link rel="dns-prefetch" href="//www.googletagmanager.com" />
        
        {/* Preconnect to external domains */}
        <link rel="preconnect" href="https://www.googletagmanager.com" crossOrigin="anonymous" />
        
        {/* Favicon links */}
        <link rel="icon" type="image/png" sizes="16x16" href="/images/optimized/favicon-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/images/optimized/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="48x48" href="/images/optimized/favicon-48x48.png" />
        <link rel="icon" type="image/png" sizes="64x64" href="/images/optimized/favicon-64x64.png" />
        <link rel="icon" type="image/png" sizes="128x128" href="/images/optimized/favicon-128x128.png" />
        <link rel="icon" type="image/png" sizes="256x256" href="/images/optimized/favicon-256x256.png" />
        <link rel="apple-touch-icon" href="/images/optimized/favicon-128x128.png" />
        

        
        {/* PWA manifest */}
        <link rel="manifest" href="/manifest.json" />
        
        {/* Apple-specific meta tags */}
        <meta name="apple-mobile-web-app-title" content="Partners Plumbing" />
        <meta name="theme-color" content="#1e293b" />
        <meta name="color-scheme" content="light" />
      </Head>

      <CriticalCSS />
      
      <ApolloProvider client={client}>
        <Component {...pageProps} />
      </ApolloProvider>
    </>
  );
} 